















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { BIcon, BIconPlay } from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconPlay,
  },
})
export default class Video extends Vue {
  protected clickedV = "";
  protected title = "";
  protected root = "";
  protected H = 0;
  protected W = 0;
  protected tooglev(vidLink: string, vidT: string, vidR: string): void {
    this.clickedV = vidLink;
    this.title = vidT;
    this.root = vidR;
    this.H = 315;
    this.W = 560;
  }
  @Prop() protected readonly galeryVideo!: {
    videoSrc: string;
    videoTitle: string;
    videoRoot: string;
  }[];
  @Prop() protected readonly idVideo!: string;
}
